import React, { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, Disclosure, Menu, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  BellIcon,
  BriefcaseIcon,
  BuildingLibraryIcon,
  ChartBarIcon,
  ClipboardDocumentCheckIcon,
  HomeIcon,
  XMarkIcon,
  ShoppingBagIcon,
  ReceiptPercentIcon,
  SwatchIcon,
  CurrencyRupeeIcon,
  ExclamationCircleIcon,
  EyeSlashIcon,
} from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  ChevronRightIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  MagnifyingGlassIcon,
  RectangleGroupIcon,
  SquaresPlusIcon,
} from "@heroicons/react/20/solid";
import { DataContext } from "../../helper/HelperOne";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserGroupIcon } from "@heroicons/react/24/outline";
import { UserCircleIcon } from "@heroicons/react/16/solid";
import {
  ClipboardDocumentIcon,
  Cog8ToothIcon,
  DocumentArrowDownIcon,
  ShieldCheckIcon,
  UsersIcon,
} from "@heroicons/react/24/solid";
import { GlobeAltIcon } from "@heroicons/react/24/solid";
// import DreamsLogo from "../../../images/logo192.png";
import LeadsLogo from "../../../images/Leads.png";
import { BiExitFullscreen, BiFullscreen } from "react-icons/bi";
import { Link } from "react-router-dom";
import { DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon, Eye, EyeIcon, EyeOff } from "lucide-react";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function NavBar(props) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { searchUi, setSearchData } = useContext(DataContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [navigation, setNavigation] = React.useState([]);
  const [userName, setUserName] = React.useState(
    localStorage.getItem("user_name")?.replaceAll('"', "")
  );
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  // const user = JSON.parse(localStorage.getItem("user"));
 
  const [user, setUser] = useState(() => {
    const userData = localStorage.getItem("user");
    return userData ? JSON.parse(userData).name : null;
  });


  const userId = JSON.parse(localStorage.getItem("user"))?.id;



  const [required, setRequired] = useState({
    old_password: "",
    new_password: "",
    new_password_confirmation: "",
  });

  // const user = {
  //   password: "murugesh@123",
  // };

  const [resetForm, setResetForm] = useState(false); // [setResetForm]
  const [passwordResetInputs, setPasswordResetInputs] = useState({
    old_password: "",
    new_password: "",
    new_password_confirmation: "",
  });
  const [oldPasswordMatch, setOldPasswordMatch] = useState(false);
  const [newPasswordLength, setNewPasswordLength] = useState(false);
  const [newPasswordMatch, setNewPasswordMatch] = useState(false);
  const [confirmation, setConfirmation] = useState(false);

  // Check if customer permissions exist and label_id & label_value are not 0
  // const customerPermission = user?.customer_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const productPermission = user?.product_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const employeePermission = user?.employee_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const leadPermission = user?.lead_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const taskPermission = user?.task_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const quotationPermission = user?.quotation_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const settingsPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const branchPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 2 && access.label_value != 0
  // );
  // const taskstatusPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 3 && access.label_value != 0
  // );
  // const taskpriorityPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 4 && access.label_value != 0
  // );
  // const taskdiscussionstatusPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 5 && access.label_value != 0
  // );

  // const quotationstatusPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 6 && access.label_value != 0
  // );

  // const leadstatusPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 7 && access.label_value != 0
  // );

  // const leadsourcePermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 8 && access.label_value != 0
  // );

  // const rolesPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 9 && access.label_value != 0
  // );

  // const rolesassignPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 10 && access.label_value != 0
  // );

  //   useEffect(() => {
  //     const initialNavigation = [];

  //     initialNavigation.push({
  //       name: "Dashboard",
  //       href: "/crm/lead_dashboard",
  //       icon: HomeIcon,
  //       current: false,
  //       id: 1,
  //     });

  //     initialNavigation.push({
  //       name: "Leads",
  //       href: "/crm/lead",
  //       icon: ChartBarIcon,
  //       current: false,
  //       id: 11,
  //     });


  // if (userId !== 1 && userId !== 2) {
  //       initialNavigation.push({
  //       name: "Workers",
  //       href: "/crm/workers",
  //       icon: UsersIcon,
  //       current: false,
  //       id: 12,
  //     });

  //     initialNavigation.push({
  //       name: "Salesman",
  //       href: "/crm/salesmen",
  //       icon: UsersIcon,
  //       current: false,
  //       id: 13,
  //     });

  //     const children = [];


  //     children.push({
  //       name: "Type Of Work",
  //       href: "/crm/type-of-work",
  //       icon: GlobeAltIcon,
  //       current: false,
  //       id: 6,
  //     });

  //     children.push({
  //       name: "Lost Reason",
  //       href: "/crm/loss-reasons",
  //       icon: GlobeAltIcon,
  //       current: false,
  //       id: 6,
  //     });

  //     children.push({
  //       name: "Advertisement Mode",
  //       href: "/crm/advertisement-mode",
  //       icon: GlobeAltIcon,
  //       current: false,
  //       id: 6,
  //     });

  //     children.push({
  //       name: "City Master",
  //       href: "/crm/cities",
  //       icon: GlobeAltIcon,
  //       current: false,
  //       id: 6,
  //     });
  //     // }

  //     // if (leadstatusPermission) {
  //     //   children.push({
  //     //     name: "Lead Status",
  //     //     href: "/crm/lead_status",
  //     //     icon: GlobeAltIcon,
  //     //     current: false,
  //     //     id: 6,
  //     //   });
  //     // }
  //     // if (leadsourcePermission) {
  //     //   children.push({
  //     //     name: "Lead Source",
  //     //     href: "/crm/lead_source",
  //     //     icon: GlobeAltIcon,
  //     //     current: false,
  //     //     id: 6,
  //     //   });
  //     // }

  //     // if (rolesPermission) {
  //     //   children.push({
  //     //     name: "Roles",
  //     //     href: "/crm/lead_role",
  //     //     icon: GlobeAltIcon,
  //     //     current: false,
  //     //     id: 6,
  //     //   });
  //     // }

  //     // if (rolesassignPermission) {
  //     //   children.push({
  //     //     name: "Roles Assign",
  //     //     href: "/crm/lead_role_assign",
  //     //     icon: GlobeAltIcon,
  //     //     current: false,
  //     //     id: 6,
  //     //   });
  //     // }

  //     initialNavigation.push({
  //       name: "Settings",
  //       icon: Cog8ToothIcon,
  //       current: false,
  //       id: 6,
  //       children,
  //     });
  //     }
  //     // }

  //     const updatedNavigation = initialNavigation.map((item) => {
  //       if (item.id === props.menuId) {
  //         return { ...item, current: true };
  //       }
  //       return { ...item, current: false };
  //     });

  //     setNavigation(updatedNavigation);
  //   }, [props.menuId]);

  useEffect(() => {
    const initialNavigation = [];

    // Always show these
    initialNavigation.push({
      name: "Dashboard",
      href: "/crm/lead_dashboard",
      icon: HomeIcon,
      current: false,
      id: 1,
    });

    initialNavigation.push({
      name: "Leads",
      href: "/crm/lead",
      icon: ChartBarIcon,
      current: false,
      id: 11,
    });

    initialNavigation.push({
      name: "Quotation",
      href: "/crm/quotation",
      icon: ClipboardDocumentIcon,
      current: false,
      id: 25,
    });

    initialNavigation.push({
      name: "Sales Order",
      href: "/crm/sale/order",
      icon: ClipboardDocumentListIcon,
      current: false,
      id: 26,
    });

    initialNavigation.push({
      name: "Sales ",
      href: "/crm/sales",
      icon: SquaresPlusIcon,
      current: false,
      id: 27,
    });

     initialNavigation.push({
      name: "Delivery Note",
      href: "/crm/delivery/note",
      icon: RectangleGroupIcon,
      current: false,
      id: 28,
    });

     initialNavigation.push({
      name: "Payment Receivable",
      href: "/crm/payment/receivable",
      icon: ReceiptPercentIcon ,
      current: false,
      id: 29,
    });




    // ✅ Only show extra menus if userId is 1 or 2
    if (userId === 1 || userId === 2) {

      const user = [
        {
          name: "Labour",
          href: "/crm/workers",
          icon: UsersIcon,
          current: false,
          id: 9,
        },
        {
          name: "Sales Person",
          href: "/crm/salesmen",
          icon: UsersIcon,
          current: false,
          id: 9,
        },
        {
          name: "Project Manager",
          href: "/crm/project/manager",
          icon: RectangleGroupIcon,
          current: false,
          id: 9,
        }
      ]

      initialNavigation.push({
        name: "Users",
        icon: UsersIcon,
        current: false,
        id: 9,
        children: user,
      });

      const item = [
        {
          name: "Lead Report",
          href: "/crm/lead_report",
          icon: ChartBarIcon,
          current: false,
          id: 10,
        },
        {
          name: "Quotation Report",
          href: "/crm/quotation_report",
          icon: ClipboardDocumentIcon,
          current: false,
          id: 10,
        },
        {
          name: "Lead Chat",
          href: "/crm/lead/chat",
          icon: ClipboardDocumentIcon,
          current: false,
          id: 10,
        },
         {
          name: "Quotation Chat",
          href: "/crm/quotation/chat",
          icon: ClipboardDocumentIcon,
          current: false,
          id: 10,
        },
        {
          name: "Missing Quotation Lead",
          href: "/crm/missing/quotation/lead/",
          icon: ClipboardDocumentIcon,
          current: false,
          id: 10,
        },
      ]

      initialNavigation.push({
        name: "Report",
        icon: DocumentTextIcon,
        current: false,
        id: 10,
        children: item,
      });



      const children = [
        {
          name: "Type Of Work",
          href: "/crm/type-of-work",
          icon: GlobeAltIcon,
          current: false,
          id: 6,
        },
        {
          name: "Lead Lost Reason",
          href: "/crm/loss-reasons",
          icon: GlobeAltIcon,
          current: false,
          id: 6,
        },
        {
          name: "Quotation Lost Reason",
          href: "/crm/quotation/loss-reasons",
          icon: GlobeAltIcon,
          current: false,
          id: 6,
        },
        {
          name: "Advertisement Mode",
          href: "/crm/advertisement-mode",
          icon: GlobeAltIcon,
          current: false,
          id: 6,
        },
        {
          name: "City Master",
          href: "/crm/cities",
          icon: GlobeAltIcon,
          current: false,
          id: 6,
        },

        {
          name: "Priority ",
          href: "/crm/Priority",
          icon: GlobeAltIcon,
          current: false,
          id: 6,
        },
        {
          name: "Sales Order Status",
          href: "/crm/sales/order/status",
          icon: GlobeAltIcon,
          current: false,
          id: 6,
        },

      ];

      initialNavigation.push({
        name: "Settings",
        icon: Cog8ToothIcon,
        current: false,
        id: 6,
        children,
      });
    }

    // Highlight current menu
    const updatedNavigation = initialNavigation.map((item) => ({
      ...item,
      current: item.id === props.menuId,
    }));

    setNavigation(updatedNavigation);
  }, [props.menuId, userId]);


  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        setShowToast(false);
      }, 3000); // 2000ms = 2 seconds

      return () => clearTimeout(timer); // cleanup
    }
  }, [showToast]);

  const search = (e) => {
    setSearchData(e.target.value);
  };

  const handleSignOut = async () => {
    setIsLoading(true);
    setHasError(false);
    var token = localStorage.getItem("token");

    try {
      const res = await axios.post("public/api/logout", [], {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });


      if (res.data.success) {
        localStorage.removeItem("token");
        // localStorage.removeItem("role_id");
        localStorage.removeItem("user");
        localStorage.removeItem("user_id");
        localStorage.removeItem("user_name");
        localStorage.removeItem("tab_name");
       
        navigate("/crm/");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
      console.error("Error during sign out:", error);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setResetForm(true);
  };

  const userNavigation = [
    { name: "Reset Password", href: "#", onClick: handleResetPassword },
    { name: "Sign out", href: "#", onClick: handleSignOut },

  ];

  const renderLoadingUI = () => (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900"></div>
        <div className="mt-4">Loading...</div>
      </div>
    </div>
  );

  const renderErrorUI = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
        <div className="flex items-center justify-center mb-6">
          <svg
            className="h-12 w-12 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <p className="text-gray-800 text-lg font-semibold mb-4 text-center">
          An error occurred during sign out.
        </p>
        <p className="text-gray-600 mb-8 text-center">
          Please check your internet connection and try again.
        </p>
        <div className="flex justify-center">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded transition duration-300"
            onClick={handleSignOut}
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );

  const toggleFullScreen = () => {
    const doc = window.document;
    const docEl = doc.documentElement;

    const requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;
    const exitFullScreen =
      doc.exitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen ||
      doc.msExitFullscreen;

    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      requestFullScreen.call(docEl);
    } else {
      exitFullScreen.call(doc);
    }
  };

  const handleChangeForPasswordReset = (e) => {
    const { name, value } = e.target;

    setPasswordResetInputs((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "old_password") {
      user !== value ? setOldPasswordMatch(true) : setOldPasswordMatch(false);
      value === "" && setOldPasswordMatch(false);
    }
    if (name === "new_password") {
      value.length < 8
        ? setNewPasswordLength(true)
        : setNewPasswordLength(false);
      value === "" && setNewPasswordLength(false);
    }
    if (name === "new_password_confirmation") {
      passwordResetInputs.new_password !== value
        ? setNewPasswordMatch(true)
        : setNewPasswordMatch(false);
      value === "" && setNewPasswordMatch(false);
    }
  };

  const ShowConfirmationForPasswordReset = () => {
    setConfirmation(true);
  };

  const handleSubmitResetPassword = async (e) => {
 

    e.preventDefault();
    const token = localStorage.getItem("token");
    

    try {
      const res = await axios.post(
        "public/api/reset-password",
        passwordResetInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
     

      if (res.data.success) {
        setToastMessage(res.data.message);
        setShowToast(true);

        localStorage.clear();

        setTimeout(() => {
          navigate("/crm/");
        }, 2000);


      }

      setUser(passwordResetInputs.new_password_confirmation);
      setConfirmation(false);
      setResetForm(false);
      setPasswordResetInputs({
        old_password: "",
        new_password: "",
        new_password_confirmation: "",
      });
    } catch (error) {
     

      setRequired(error.response.data.errors);
    }
  };

  const handleCloseResetForm = () => {
    setPasswordResetInputs({
      old_password: "",
      new_password: "",
      new_password_confirmation: "",
    });
    setResetForm(false);
    setRequired({
      old_password: "",
      new_password: "",
      new_password_confirmation: "",
    });
  };

  return (
    <>
      <div>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 flex z-40 md:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div className="flex h-20 shrink-0 items-center justify-center">
                  <img
                    className="h-20 w-auto ml-4"
                    src={LeadsLogo}
                    alt="Workflow"
                  />
                </div>
                <div className="mt-5 flex-1 h-0 overflow-y-auto">
                  <nav
                    className="flex-1 px-2 space-y-1 bg-white"
                    aria-label="Sidebar"
                  >
                    {navigation.map((item) =>
                      !item.children ? (
                        <div key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.current
                                ? "bg-gray-50 text-indigo-600"
                                : "hover:text-indigo-600 hover:bg-gray-50",
                              "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold text-gray-700"
                            )}
                          >
                            <item.icon
                              className={classNames(
                                item.current
                                  ? "text-indigo-600"
                                  : "text-gray-400 group-hover:text-indigo-600",
                                "h-6 w-6 shrink-0"
                              )}
                              aria-hidden="true"
                            />

                            {item.name}
                          </a>
                        </div>
                      ) : (
                        <Disclosure
                          as="div"
                          key={item.name}
                          className="space-y-1"
                          defaultOpen={
                            (props.menuId == 6 && item.name == "Settings") ||
                            (props.menuId == 10 && item.name == "Report") ||
                            (props.menuId == 9 && item.name == "Users")
                          }
                        >
                          {({ open }) => (
                            <>
                              <Disclosure.Button
                                className={classNames(
                                  item.current
                                    ? "bg-gray-50 text-indigo-600"
                                    : "hover:text-indigo-600 hover:bg-gray-50",
                                  "flex items-center w-full text-left rounded-md p-2 gap-x-3 text-sm leading-6 font-semibold text-gray-700"
                                )}
                              >
                                <item.icon
                                  className={classNames(
                                    item.current
                                      ? "text-indigo-600"
                                      : "text-gray-400 group-hover:text-indigo-600",
                                    "h-6 w-6 shrink-0"
                                  )}
                                  aria-hidden="true"
                                />

                                <span className="flex-1">{item.name}</span>
                                <ChevronRightIcon
                                  className={classNames(
                                    open
                                      ? "rotate-90 text-gray-500"
                                      : "text-gray-400",
                                    "ml-auto h-5 w-5 shrink-0"
                                  )}
                                  aria-hidden="true"
                                />
                              </Disclosure.Button>
                              <Disclosure.Panel className="space-y-1">
                                {item.children.map((subItem) => (
                                  <Disclosure.Button
                                    key={subItem.name}
                                    as="a"
                                    href={subItem.href}
                                    className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
                                  >
                                    {subItem.name}
                                  </Disclosure.Button>
                                ))}
                              </Disclosure.Panel>
                            </>
                          )}
                        </Disclosure>
                      )
                    )}
                  </nav>
                  {/*<div className="flex flex-shrink-0 border-t border-gray-200 p-4">
                    <a className="group block w-full flex-shrink-0">
                      <div className="flex items-center">
                        <div className="ml-3">
                          <p className="text-sm font-medium text-gray-700">
                            @ Dreams
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>*/}
                </div>
              </div>
            </Transition.Child>
            <div className="flex-shrink-0 w-14">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex flex-col flex-grow border-r border-gray-200 bg-white overflow-y-auto">
            <div className="px-8 flex h-20 shrink-0 items-center justify-center p-3">
              <img className="h-20 w-auto" src={LeadsLogo} />
            </div>
            <div className="mt-5 flex-grow flex flex-col">
              <nav
                className="flex-1 px-2 space-y-1 bg-white"
                aria-label="Sidebar"
              >
                {navigation.map((item) =>
                  !item.children ? (
                    <div key={item.name}>
                      <Link
                        to={item.href}
                        className={classNames(
                          item.current
                            ? "bg-gray-50 text-indigo-600"
                            : "hover:text-indigo-600 hover:bg-gray-50",
                          "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold text-gray-700"
                        )}
                      >
                        <item.icon
                          className={classNames(
                            item.current
                              ? "text-indigo-600"
                              : "text-gray-400 group-hover:text-indigo-600",
                            "h-6 w-6 shrink-0"
                          )}
                          aria-hidden="true"
                        />
                        {item.name}
                      </Link>
                    </div>
                  ) : (
                    <Disclosure
                      as="div"
                      key={item.name}
                      className="space-y-1"
                      defaultOpen={
                        (props.menuId == 6 && item.name == "Settings") ||
                        (props.menuId == 10 && item.name == "Report") ||
                        (props.menuId == 9 && item.name == "Users")
                      }
                    >

                      {({ open }) => (
                        <>
                          <Disclosure.Button
                            className={classNames(
                              item.current
                                ? "bg-gray-50 text-indigo-600"
                                : "hover:text-indigo-600 hover:bg-gray-50",
                              "flex items-center w-full text-left rounded-md p-2 gap-x-3 text-sm leading-6 font-semibold text-gray-700"
                            )}
                          >
                            <item.icon
                              className={classNames(
                                item.current
                                  ? "text-indigo-600"
                                  : "text-gray-400 group-hover:text-indigo-600",
                                "h-6 w-6 shrink-0 mr-3"
                              )}
                              aria-hidden="true"
                            />

                            <span className="flex-1">{item.name}</span>
                            <ChevronRightIcon
                              className={classNames(
                                open
                                  ? "rotate-90 text-gray-500"
                                  : "text-gray-400",
                                "ml-auto h-5 w-5 shrink-0"
                              )}
                              aria-hidden="true"
                            />
                          </Disclosure.Button>
                          <Disclosure.Panel className="space-y-1">
                            {item.children.map((subItem) => (
                              <Link
                                key={subItem.name}
                                as="a"
                                to={subItem.href}
                                className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
                              >
                                {subItem.name}
                              </Link>
                            ))}
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  )
                )}
              </nav>
              {/* <div className="flex flex-shrink-0 border-t border-gray-200 p-4">
                <a className="group block w-full flex-shrink-0">
                  <div className="flex items-center">
                    <div className="ml-3">
                      <p className="text-sm font-medium text-gray-700">
                        @ Dreams
                      </p>
                    </div>
                  </div>
                </a>
              </div> */}
            </div>
          </div>
        </div>
        <div className="md:pl-64 flex flex-col flex-1">
          <div className="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow">
            <button
              type="button"
              className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            <div className="flex-1 px-4 flex justify-between">
              <div className="flex-1 flex">
                <form className="w-full flex md:ml-0" action="#" method="GET">
                  {searchUi && (
                    <form
                      className="relative flex flex-1"
                      action="#"
                      method="GET"
                    >
                      <label htmlFor="search-field" className="sr-only">
                        Search
                      </label>
                      <MagnifyingGlassIcon
                        className="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400"
                        aria-hidden="true"
                      />
                      <input
                        id="search-field"
                        className="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
                        placeholder="Search..."
                        type="search"
                        onChange={search}
                        name="search"
                      />
                    </form>
                  )}
                </form>
              </div>
              <div className="ml-4 flex items-center md:ml-6">
                <div className="flex items-center gap-x-4 lg:gap-x-6">
                  <button
                    type="button"
                    className="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500"
                    onClick={toggleFullScreen}
                  >
                    {document.fullscreenElement ? (
                      <BiExitFullscreen
                        className="h-6 w-6"
                        aria-hidden="true"
                      />
                    ) : (
                      <BiFullscreen className="h-6 w-6" aria-hidden="true" />
                    )}
                  </button>

                  {/* <button type="button" className="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500">
                                        <span className="sr-only">View notifications</span>
                                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                                    </button> */}

                  {/* Separator */}
                  <div
                    className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
                    aria-hidden="true"
                  />

                  {/* Profile dropdown */}
                  <Menu as="div" className="relative">
                    <Menu.Button className="-m-1.5 flex items-center p-1.5">
                      <span className="sr-only">Open user menu</span>
                      <span className="inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100">
                        <svg
                          className="h-full w-full text-gray-300"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                      </span>
                      <span className="hidden lg:flex lg:items-center">
                        <span
                          className="ml-4 text-sm font-semibold leading-6 text-gray-900"
                          aria-hidden="true"
                        >
                          {userName}
                        </span>
                        <ChevronDownIcon
                          className="ml-2 h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2.5 w-42 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                        {userNavigation.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <a
                                href={item.href}
                                onClick={
                                  item.onClick ? item.onClick : undefined
                                }
                                className={classNames(
                                  active ? "bg-gray-50" : "",
                                  "block px-3 py-1 text-sm leading-6 text-gray-900"
                                )}
                              >
                                {item.name}
                              </a>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>
            </div>
          </div>

          {isLoading ? (
            renderLoadingUI()
          ) : hasError ? (
            renderErrorUI()
          ) : (
            <div className="bg-gray-200">
              <body className=" sm:p-4 min-h-screen">
                <main className="h-full shadow-md bg-white p-4 rounded">
                  <div>
                    <div>{props.childrenPage}</div>
                  </div>
                </main>
              </body>
            </div>
          )}
        </div>
      </div>

      {resetForm && (
        <Dialog open={resetForm} onClose={() => { }} className="relative z-10">
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

          {/* Modal */}
          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Dialog.Panel className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
              <div className="flex items-center justify-between ">
                <p className="text-[18px] font-semibold text-gray-900">
                  Password Reset Form
                </p>
                <XMarkIcon
                  onClick={handleCloseResetForm}
                  className="h-6 w-6 cursor-pointer bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
                />
              </div>

              {/* Form */}
              <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-4">
                <div className="sm:col-span-4">
                  <label
                    htmlFor="oldpassword"
                    className="block text-[14px] text-gray-500"
                  >
                    Old Password
                  </label>
                  <div className="mt-2">
                    <div className="flex  items-center rounded-lg bg-white">
                      <input
                        id="oldpassword"
                        name="old_password"
                        type="text"
                        value={passwordResetInputs.old_password}
                        onChange={handleChangeForPasswordReset}
                        placeholder="Current password to verify identity"
                        className="block border border-gray-300 rounded placeholder:text-[14px] min-w-0 grow py-1.5 pr-3 pl-2 text-base text-gray-600 placeholder:text-gray-400 focus:outline-none sm:text-[16px]"
                      />
                    </div>
                  </div>
                  {required.old_password && (
                    <p className="text-red-500 text-xs mt-2">
                      {required.old_password}
                    </p>
                  )}
                </div>
                <div className="sm:col-span-4">
                  <label
                    htmlFor="newpassword"
                    className="block text-[14px] text-gray-500"
                  >
                    New Password
                  </label>
                  <div className="mt-2">
                    <div className="flex items-center rounded-lg bg-white border border-gray-300">
                      <input
                        id="newpassword"
                        name="new_password"
                        type={showPassword ? "text" : "password"}
                        value={passwordResetInputs.new_password}
                        onChange={handleChangeForPasswordReset}
                        placeholder="8+ characters, symbols recommended"
                        className="block placeholder:text-[14px] min-w-0 grow py-1.5 pr-3 pl-2 text-base text-gray-600 placeholder:text-gray-400 focus:outline-none sm:text-[16px]"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword((prev) => !prev)}
                        className="px-2 text-gray-600 focus:outline-none"
                      >
                        {showPassword ? (
                          <EyeOff size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </button>
                    </div>
                  </div>
                  {required.new_password && (
                    <p className="text-red-500 text-xs mt-2">
                      {required.new_password}
                    </p>
                  )}
                </div>
                {/* Confirm Password */}
                <div className="sm:col-span-4">
                  <label
                    htmlFor="confirmpassword"
                    className="block text-[14px] text-gray-500"
                  >
                    Confirm Password
                  </label>
                  <div className="mt-2">
                    <div className="flex items-center rounded-lg bg-white relative">
                      <input
                        id="confirmpassword"
                        name="new_password_confirmation"
                        type={showConfirmPassword ? "text" : "password"}
                        value={passwordResetInputs.new_password_confirmation}
                        onChange={handleChangeForPasswordReset}
                        placeholder="Confirm your new password"
                        className="block border border-gray-300 rounded placeholder:text-[14px] min-w-0 grow py-1.5 pr-10 pl-2 text-base text-gray-600 placeholder:text-gray-400 focus:outline-none sm:text-[16px]"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        className="absolute right-2 text-gray-500"
                      >
                        {showConfirmPassword ? (
                          <EyeSlashIcon className="h-5 w-5" />
                        ) : (
                          <EyeIcon className="h-5 w-5" />
                        )}
                      </button>
                    </div>
                    {required.new_password_confirmation && (
                      <div className="mt-2 flex items-start gap-1 text-xs text-red-600">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01M12 2a10 10 0 1010 10A10 10 0 0012 2z"
                          />
                        </svg>
                        <p>{required.new_password_confirmation}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-6 flex justify-end gap-3">
                <button
                  className="px-4 py-2 rounded-md text-[14px] bg-gray-100 text-gray-700 hover:bg-gray-200"
                  onClick={handleCloseResetForm}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 rounded-md text-[14px] bg-green-800 text-white hover:bg-green-700"
                  onClick={handleSubmitResetPassword}
                >
                  Submit
                </button>
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      )}

      {confirmation && (
        <div>
          <Dialog
            open={confirmation}
            onClose={() => setConfirmation(false)}
            className="relative z-[60]"
          >
            {/* Backdrop */}
            <div
              className="fixed inset-0 bg-gray-500/75 transition-opacity z-[60]"
              aria-hidden="true"
            />

            {/* Modal content */}
            <div className="fixed inset-0 z-[60] w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                  <div>
                    <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100">
                      <ExclamationCircleIcon
                        aria-hidden="true"
                        className="size-6 text-red-600"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-5">
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold text-gray-900"
                      >
                        Confirmation Reset Password
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to reset your password?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-6 flex flex-row justify-between gap-4">
                    <button
                      type="button"
                      onClick={() => setConfirmation(false)}
                      className="inline-flex w-full justify-center rounded-md bg-red-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      onClick={handleSubmitResetPassword}
                      className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                    >
                      Yes
                    </button>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        </div>
      )}

      {showToast && (
        <div
          aria-live="assertive"
          className="pointer-events-none mt-16 mr-10 fixed top-4 right-4 z-50 flex items-center space-x-2 rounded-lg bg-white px-4 py-3 shadow-lg ring-1 ring-black/10"
        >


          <p className="flex items-center gap-2 text-sm font-medium text-gray-800">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
            Logging Out... {toastMessage}
          </p>




          <button
            onClick={() => setShowToast(false)}
            className="ml-2 rounded-md text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>

        </div>
      )}
    </>
  );
}
